import { render } from "./InputCoinAmountSkeleton.vue?vue&type=template&id=89ede5e2&scoped=true"
import script from "./InputCoinAmountSkeleton.vue?vue&type=script&lang=js"
export * from "./InputCoinAmountSkeleton.vue?vue&type=script&lang=js"

import "./InputCoinAmountSkeleton.vue?vue&type=style&index=0&id=89ede5e2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89ede5e2"]])

export default __exports__